module.exports = __webpack_public_path__ + "static/img/bg_05.d9ef519.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_05.jpg
// module id = 7UGH
// module chunks = 3 4